import {
  isMsalInteractionRequiredError,
  isMsalSilentIframeTimeoutError,
  isMsalTokenExpirationError,
} from "utils/msalAuthErrors";
import { isNetworkFetchError } from "utils/networkErrors";
import { isCustomAppSessionLifecycleValid } from "services/msalSessionRecovery";
import {
  clearWakeAuthPhase,
  isWakeAuthPhaseActive,
} from "utils/wakeAuthPhase";

let wakeRedirectTriggered = false;

/**
 * Resets the one-shot wake redirect guard (e.g. after a successful re-login).
 */
export function resetWakePhaseAuthFailureGuard() {
  wakeRedirectTriggered = false;
}

/**
 * During the wake-up window, network or auth/session failures should route to
 * interactive login instead of surfacing as uncaught promise rejections.
 *
 * @param {unknown} error
 * @param {() => void} signinHandler
 * @returns {boolean} True when interactive login was triggered.
 */
export function handleWakePhaseAuthFailure(error, signinHandler) {
  if (
    wakeRedirectTriggered ||
    !isWakeAuthPhaseActive() ||
    typeof signinHandler !== "function"
  ) {
    return false;
  }

  const shouldRedirect =
    isNetworkFetchError(error) ||
    isMsalInteractionRequiredError(error) ||
    isMsalTokenExpirationError(error);

  if (
    isMsalSilentIframeTimeoutError(error) &&
    isCustomAppSessionLifecycleValid()
  ) {
    return false;
  }

  if (!shouldRedirect) {
    return false;
  }

  wakeRedirectTriggered = true;
  clearWakeAuthPhase();
  signinHandler();
  return true;
}
